
























































































































import { Component, Vue, Watch } from "vue-property-decorator";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { IBanco, BancoDTO} from "@/models/commons/BancoModel";
import ServicosAssistenciaService from "@/service/assistencia24h/ServicosAssistenciaService";

@Component({
  components: {
    GsModalDialog,
  },
})
export default class ListaPrestadores extends Vue {
  valores: BancoDTO[] = [];
  loading = false;
  cabecalho = [
      { text: "Código", value: "id", width: "20%" },
      { text: "Banco", value: "descricao", width: "60%" },
      { text: "Ações", value: "actions", width: "15%", sortable: false }
  ];
  salvarBanco: BancoDTO = {
    id: "",
    descricao: ""
  };
  banco: IBanco = { 
    id:"", 
    descricao: ""
  };
  dialogType = "sucess";
  showDialog = false;
  dialogTitle = "";
  dialogMessage = "";

  alterarConfiguracao(bancos: IBanco) {
    this.banco = Object.assign({}, bancos);
  }

  beforeMount() {
    this.obterBancos();
  }

  obterBancos() {
    this.loading = true;
    this.valores = [];
    ServicosAssistenciaService
    .obterBancos().then((res: BancoDTO[]) => {
          this.valores = res;
          this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
      });
  }

  salvarValorPercentual() {
    this.salvarBanco.id = this.banco.id;
    this.salvarBanco.descricao = this.banco.descricao;
    ServicosAssistenciaService
    .salvarBancos(
      this.salvarBanco
    ).then((res: BancoDTO) => {
      this.resetBancos();
      this.openDialog('success', "Alteração realizada com sucesso", "Alteração realizada com sucesso");
    })
    .catch((err) => {
        console.log(err);
        this.openDialog('error', 'Erro ao realizar alteração.', 'Ocorreu um erro ao tentar gravar os dados.');
      });
  }

  realizarExclusao(Banco: IBanco) {
    ServicosAssistenciaService.excluirBanco(Banco.id)
    .then(() => {
      this.obterBancos();  
      this.openDialog('success', "Exclusão do banco efetuada com sucesso.", "Exclusão do banco efetuada com sucesso.");
    })
    .catch(() => {
       this.openDialog('error', 'Erro ao realizar a exclusão do banco.', 'Erro ao realizar a exclusão do banco. Verifique se o banco não está cadastrado para algum prestador.');
    })
  }

  resetBancos() {
    this.banco.id = "";
    this.banco.descricao = "";
    this.obterBancos();
  }

  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }

  public closeDialog(): void {
    this.showDialog = false;
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      case "confirm":
        color = "warning";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }
}
